import { Component, Input } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { DishCreateNutritionPage } from '../../../dish/dish-create/dish-create-nutrition/dish-create-nutrition';

/**
 * Generated class for the ArticleViewNutritionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-article-view-nutrition',
    templateUrl: 'article-view-nutrition.html',
})
export class ArticleViewNutritionPage {
    @Input() article: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals) {
    }

    edit() {
        if (this.globals.checkLimitsByLicense('dishes', 'nutrition')) {//version pro abierto
            this.navCtrl.push(DishCreateNutritionPage, {
                update: true,
                dish_uid: this.article.UID,
                dish_name: this.globals.nameLangSelectDish(this.article),
                dish: this.article
            })
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view-nutrition/article-view-nutrition.ts